/// <amd-module name="Dashboards/DashboardView/src/redux/actions/ErrorActions" />
import { ActionsUnion, createAction, trackedErrorAction } from "redux/Utils/ActionHelper";

export const enum ErrorActionTypes {
    DismissErrorMessage = "DashboardView/DismissErrorMessage",
    NotifySagaFailure = "DashboardView/Error/SagaFailure",
    NotifyDashboardLoadFailure = "DashboardView/Error/DashboardLoadFailure",
    NotifyDashboardSaveFailure = "DashboardView/Error/DashboardSaveFailure"
}

export namespace ErrorActions {
    export const dismissErrorMessage = () => createAction(ErrorActionTypes.DismissErrorMessage);
    export const notifySagaFailure = (error: Error) => trackedErrorAction(createAction(ErrorActionTypes.NotifySagaFailure, error));
    export const notifyDashboardLoadFailure = (error: Error) => trackedErrorAction(createAction(ErrorActionTypes.NotifyDashboardLoadFailure, error));
    export const notifyDashboardSaveFailure = (error: Error) => trackedErrorAction(createAction(ErrorActionTypes.NotifyDashboardSaveFailure, error));
}

export type ErrorAction = ActionsUnion<typeof ErrorActions>;
